<p-dialog
  [styleClass]="'popup_error'"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [style]="{ width: '32%' }"
  [modal]="true"
  [visible]="show_Dialog"
>
  <ng-template pTemplate="header">
    <div class="flex wd-100 dialog_header_wrapper align-items-center justify-content-between ng-star-inserted">
      <span class="text-xl font-bold">{{ title }}</span>
      <p-button
        icon="pi pi-times"
        (onClick)="hide()"
        styleClass="p-button-rounded p-button-danger p-button-text p-button-raised"
      ></p-button>
    </div>
  </ng-template>

  <div class="content_wrapper">
    <div class="iconSize">
      <i class="pi pi-exclamation-triangle"></i>
    </div>
    <p class="message">{{ message }}</p>
  </div>

  <div class="dialog_footer mt-4">
    <div class="flex align-items-center justify-content-end">
      <p-button
        type="button"
        label="Close"
        class="p-button-text elevated-btn secondary"
        [style]="{ color: 'black' }"
        (click)="hide()"
      ></p-button>
    </div>
  </div>
</p-dialog>


